/** @jsxImportSource theme-ui */
import React from 'react';
import { SxProp } from 'theme-ui';

import { RiskLikelihood, RiskMagnitude } from 'models/RiskCategories';

import { BdImportationRiskIcon } from 'components/_common/Icon/BdImportationRiskIcon';
import { Typography } from 'components/_common/Typography';

type RiskOverviewImportationSummaryProps = SxProp & {
  riskMagnitude: RiskMagnitude;
  riskLikelihood: RiskLikelihood;
  title: string;
  subtitle: string;
};

const RiskOverviewImportationSummary: React.FC<RiskOverviewImportationSummaryProps> = ({
  riskMagnitude,
  riskLikelihood,
  title,
  subtitle,
  ...props
}) => {
  return (
    <div
      data-testid="ro-importation-summary"
      sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: ['100%', '50%'],
        maxWidth: ['100%', '50%'],
        padding: '0',
        ml: '0',
        mb: ['24px', '0', '0'],
      }}
      {...props}
    >
      <div
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          padding: '0',
        }}
      >
        <BdImportationRiskIcon riskMagnitude={riskMagnitude} riskLikelihood={riskLikelihood} />
      </div>
      <div
        className="ro-importation-summary-text"
        sx={{ display: 'flex', flexDirection: 'column', ml: '4px' }}
      >
        <Typography variant="h6" color="stone90" marginBottom="4px">
          {title}
        </Typography>
        <Typography variant="caption" color="stone70" marginBottom="0">
          {subtitle}
        </Typography>
      </div>
    </div>
  );
};

export default RiskOverviewImportationSummary;
